import React, { useState, useEffect } from "react";
import { ContainerForm } from "./ContainerForm";
import { RuntimeComponent } from "./RuntimeComponent";
import axios from "axios";
import { ProgramContainer } from "./entities/formTemplateDataType";
import URLUtils, { getAppNameFromPath } from "./utilities/URLUtils";
import { RuntimeWithLayout } from "./RuntimeWithLayout";
import { RuntimeApp } from "./RuntimeApp";
import SvgSymbols from './SvgSymbols';
import msalInstance from "./security/msalInstance";
import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";
import { getAdminConfig } from "./services/EnvConfigService";
import * as CircularJSON from 'circular-json';
const App: React.FC = () => {
  const [programContainer, setProgramContainer] = useState<ProgramContainer | null>(null);

  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (process.env.IS_RUNTIME === 'true') {
      loadData();
    }
  }, [isAuthenticated]); 

  const loadData = async () => {
    const categoryId = getAppNameFromPath();
    // let storedUrl = sessionStorage.getItem('preAuthUrl');
   
    // if (storedUrl && !storedUrl.includes("#code=")) {
    //   storedUrl = storedUrl.replace("/fr", "");
    //   let pathSegmentsAll = storedUrl.split('#');

    //   if (pathSegmentsAll.length > 1) {
    //     const categoryId = pathSegmentsAll[1];
    if (categoryId) {
        const url = "data/admin/get/" + categoryId.toLowerCase();
        const urlFull = URLUtils.concatUrls(url);

        try {
          const response = await axios.get(urlFull);
          
          let parsedProgramContainer = CircularJSON.parse(response.data.attachment) as ProgramContainer;
           console.log(parsedProgramContainer);
          const adminConfig = await getAdminConfig(parsedProgramContainer.CategoryId);
          parsedProgramContainer.adminConfig = adminConfig;
          setProgramContainer(parsedProgramContainer);
          if(!parsedProgramContainer.AuthRequired)
          sessionStorage.removeItem("preAuthUrl");
        } catch (ex) {
          console.log(ex);
        }
    }
    // }
  };

  if(programContainer?.AuthRequired && !sessionStorage.getItem("preAuthUrl") && !window.location.href.includes("code=")){
    sessionStorage.setItem("preAuthUrl", window.location.href);
  }
 
  const html = [<SvgSymbols key="svg-symbols" />];

  switch (process.env.IS_RUNTIME) {
    case 'false':
      html.push(<ContainerForm key="container-form" />);
      break;
    case 'true':
      if (!programContainer) return null;
      html.push(
        programContainer.AuthRequired === 'ad' ? (
          <MsalProvider key="msal-provider" instance={msalInstance}>
            <RuntimeComponent programContainer={programContainer} />
          </MsalProvider>
        ) : (
          <RuntimeComponent key="runtime-component" programContainer={programContainer} />
        )
      );
      break;
    case 'withLayout':
      html.push(<RuntimeWithLayout key="runtime-with-layout" />);
      break;
    case 'deployed':
      html.push(<RuntimeApp key="runtime-app" />);
      break;
  }

  return <>{html}</>;
};

export default App;
